module.exports = __webpack_public_path__ + "static/media/german-word-for-brown.c7114355.jpg";